<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Sample Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading :title="`Update ${sample.publicNumber()}`" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="['edit sample']">
      <template #gated-content>
        <sample-card :sample="sample" />

        <SampleApplyTestPackageForm :sample="sample" @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from 'vue'
import VueNotifications from 'vue-notifications'
import { notificationOptions } from '@/shared/toast-notification-options'
import { getModel } from '@/shared/fetch-utils'
import { sampleNotifications } from '@/shared/notifications'
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import PermissionAlertGate from '@/components/permission/PermissionAlertGate'
import SampleApplyTestPackageForm from '@/components/lab/sample/SampleApplyTestPackageForm'
import TestPackageModel from '@/models/lab/TestPackageModel'

Vue.use(VueNotifications, notificationOptions)

export default {
  name: 'SampleApplyTestPackage',
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    SampleApplyTestPackageForm
  },
  data () {
    return {
      loading: true,
      sample_id: this.$route.params.sample_id || null,
      sample: null
    }
  },
  computed: {
    button_config () {
      return {
        buttons: [
          {
            icon: "fa-eye",
            linkto: `/samples/${this.sample_id}`,
            title: "View sample",
            variant: "info",
          },
        ]
      }
    },
  },
  async mounted () {
    this.loading = true

    this.sample = await getModel({
      model_type: 'sample',
      id: this.sample_id,
      message: this.$bvToast
    })

    this.loading = false
  },
  methods: {
    async submit (form_data) {
      try {
        const test_package_model = new TestPackageModel({ id: form_data.selected_test_package })

        await test_package_model.apply({
          samples: [this.sample.id],
        })


        this.editSuccess()
        this.$router.push(`/samples/${this.sample_id}`)
      } catch ({ response }) {
        const { status, data } = response.response;

        this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
          title: "Server Error.",
          variant: "danger",
        })
      }
    }
  },
  notifications: sampleNotifications
}
</script>
